











































































































































































































































































































































































































































































import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";
import DeleteDialog from "../components/dialogs/DeleteDialog.vue";
import FileUploadDialog from "../components/dialogs/FileUploadDialog.vue";
import FileReplaceDialog from "../components/dialogs/FileReplaceDialog.vue";
import FolderDialog from "../components/dialogs/FolderDialog.vue";
import ProgressDialog from "../components/dialogs/ProgressDialog.vue";

import SnackbarStore from "@/ts/stores/SnackbarStore";
import FileUploadDialogStore from "@/ts/stores/FileUploadDialogStore";
import FileReplaceDialogStore from "@/ts/stores/FileReplaceDialogStore";
import FolderDialogStore from "@/ts/stores/FolderDialogStore";
import ProgressDialogStore from "@/ts/stores/ProgressDialogStore";

import AppPackages from "@/API/AppPackages";
import Templates from "@/API/Templates";

import Package from "@/ts/interfaces/Package";
import Folder from "@/ts/interfaces/Folder";
import File from "@/ts/interfaces/File";
import Errors from "@/ts/interfaces/Errors";

import FolderListTile from "@/components/FolderListTile.vue";
import FileListTile from "@/components/FileListTile.vue";
import DeleteDialogStore from "@/ts/stores/DeleteDialogStore";
import {FolderTypeApi} from "@/ts/enums/FolderTypeApi";
import ErrorStore from "@/ts/stores/ErrorStore";

@Component({
  components: {
    MainNavigation,
    DeleteDialog,
    FileUploadDialog,
    FileReplaceDialog,
    FolderDialog,
    ProgressDialog,
    FolderListTile,
    FileListTile
  }
})

export default class PackagesDetail extends Vue {
  package: Package | null = null;

  tab = null;
  tabTitles = [
    'Angebotsstruktur', 'Projektstruktur'
  ];

  //OFFER TAB
  baseFolderOffer: Folder | null = null;
  currentFolderOffer: Folder | null = null;
  currentFolderOfferDemoPdf: string | null = "";
  currentFolderOfferDemoVideoUrl: string | null = "";
  previousFolderStackOffer: Folder[] = [];

  //PROJECT TAB
  baseFolderProject: Folder | null = null;
  currentFolderProject: Folder | null = null;
  currentFolderProjectDemoPdf: string | null = "";
  currentFolderProjectDemoVideoUrl: string | null = "";
  previousFolderStackProject: Folder[] = [];

  toEdit: Folder | File | null = null;
  deleteFolder = false;
  toDelete: File | Folder | null | any = null;

  mounted() {
    let packageID = this.$route.query.id;

    AppPackages.getSinglePackage(Number(packageID)).then(res => {
      this.package = res;
    });

    Templates.getTemplateStructure("offer", Number(packageID)).then(res => {
      this.updateOfferFolderVariables(res);
      this.baseFolderOffer = res;
      this.previousFolderStackOffer.push(res);
    });

    Templates.getTemplateStructure("project", Number(packageID)).then(res => {
      this.updateProjectFolderVariables(res);
      this.baseFolderProject = res;
      this.previousFolderStackProject.push(res);
    });

    //@ts-ignore:
    let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
    let packages = document.getElementById("icon-packages");
    let news = document.getElementById("icon-news");
    let settings = document.getElementById("icon-settings");

    //@ts-ignore:
    mandate.style = "color: rgba(0, 0, 0, 0.54)";
    //@ts-ignore:
    packages.style = "color: #81B219";
    //@ts-ignore:
    settings.style = "color: rgba(0, 0, 0, 0.54)";
    //@ts-ignore:
    news.style = "color: rgba(0, 0, 0, 0.54)";
  }

  //==============================================
  //===================REFRESH====================
  //==============================================

  refresh() {
    this.refreshOffer();
    this.refreshProject()
  }

  refreshOffer() {
    setTimeout(() => {
      Templates.getTemplateStructure("offer", Number(this.$route.query.id)).then(res => {
        this.baseFolderOffer = res;

        if (this.currentFolderOffer && this.baseFolderOffer) {
          let current = this.getPathForFolder(this.currentFolderOffer.id, this.baseFolderOffer) //this.findFolderInFolder(this.currentFolderOffer.id, this.baseFolderOffer, "offer/");
          if (current) {
            this.previousFolderStackOffer = current;
            this.updateOfferFolderVariables(current[current.length - 1]);
          }
          //Case: Ordner gelöscht oder sonst nicht aufzufinden
          else {
            this.baseFolderOffer = res;
            this.updateOfferFolderVariables(res);
            this.previousFolderStackOffer = [];
            this.previousFolderStackOffer.push(res);
            SnackbarStore.show("Ordner wurde gelöscht, wechsel zum Eingangsordner")
          }
        }
      }).catch(err => {
        if (err.message && err.message.description) {
          SnackbarStore.show(err.message.description)
        } else {
          SnackbarStore.show("Aktualisieren fehlgeschlagen")
        }
      });
    }, 1000);
  }

  refreshProject() {
    Templates.getTemplateStructure("project", Number(this.$route.query.id)).then(res => {
      this.baseFolderProject = res;

      if (this.currentFolderProject && this.baseFolderProject) {
        let current = this.getPathForFolder(this.currentFolderProject.id, this.baseFolderProject)

        if (current) {
          this.previousFolderStackProject = current;
          this.updateProjectFolderVariables(current[current.length - 1]);

        }
        //Case: Ordner gelöscht oder sonst nicht aufzufinden
        else {
          this.baseFolderProject = res;
          this.updateProjectFolderVariables(res);
          this.previousFolderStackProject = [];
          this.previousFolderStackProject.push(res);
          SnackbarStore.show("Ordner wurde gelöscht, wechsel zum Eingangsordner")
        }
      }
    }).catch(err => {
      if (err.message && err.message.description) {
        SnackbarStore.show(err.message.description)
      } else {
        SnackbarStore.show("Aktualisieren fehlgeschlagen")
      }
    });
  }

  getPathForFolder(targetId: number, folder: Folder): Folder[] | null {
    if (folder.id === targetId) {
      return [folder]
    }

    for (let subfolder of folder.folders) {
      let result = this.getPathForFolder(targetId, subfolder);
      const folders: any = result ? [...result] : [];
      if (folders.length) {
        return [folder, ...folders]
      }
    }
    return null
  }

  //==============================================
  //======SECTION DELETE CONFIRMATION DIALOG======
  //==============================================

  openDeleteDialogFolder(folder: Folder) {
    this.toEdit = folder;
    this.deleteFolder = true;
    this.toDelete = folder;
    DeleteDialogStore.show()
  }

  openDeleteDialogFile(file: File) {
    this.toEdit = file;
    this.deleteFolder = false;
    this.toDelete = file;
    DeleteDialogStore.show()
  }

  deleteItem() {
    if (this.deleteFolder) {
      if (this.toDelete) {
        Templates.deleteTemplateFolder(this.toDelete.id).then(res => {
          DeleteDialogStore.dismiss();
          if (this.currentFolderOffer && this.toDelete) {
            SnackbarStore.show("Erfolgreich gelöscht.");
            let index = this.currentFolderOffer.folders.indexOf(this.toDelete);

            if (index !== -1) {
              this.currentFolderOffer.folders.splice(index, 1);
            }
          }
        })
      }
    } else {
      Templates.deleteTemplateFile(this.toDelete.id).then(res => {
        DeleteDialogStore.dismiss();
        if (this.currentFolderOffer && this.toDelete) {
          SnackbarStore.show("Erfolgreich gelöscht.");

          let index = this.currentFolderOffer.files.indexOf(this.toDelete);

          if (index !== -1) {
            this.currentFolderOffer.files.splice(index, 1);
          }
        }
      })
    }
  }

  //==============================================
  //======SECTION UPLOAD FILE/FOLDER DIALOG=======
  //==============================================

  openFileUploadDialog(folder: Folder) {
    this.toEdit = folder;
    FileUploadDialogStore.show(folder.folder_type)
  }

  openFileReplaceDialog(folder: Folder) {
    this.toEdit = folder;
    FileReplaceDialogStore.show(folder.folder_type)
  }

  openFolderDialog(data: any) {
    this.toEdit = data.folder;
    if (data.isEdit) {
      FolderDialogStore.showEdit(data.folder, this.tab == 1)
    } else {
      this.toEdit = null;
      FolderDialogStore.show(this.tab == 1)
    }
  }

  //============================== BEGIN handling file/folder creation
  editItem(data: any) {
    FolderDialogStore.dismiss();
    Templates.updateTemplateFolder(data.id, data.name, data.order_index, data.demo_pdf_file, data.demo_video_url).then(res => {
      this.refresh()
    }).catch(res => {
      ErrorStore.showError("Fehler beim Erstellen der Dateien")
    })
  }

  //{files: ..., name: "", type: ""}
  substituteItem(data: any) {
    this.addItem(data, true)
  }

  addItem(data: any, isReplace: boolean) {
    //Case Folder creation
    if (data.name != undefined && data.folder_type !== FolderTypeApi.FORMULAR && data.folder_type !== FolderTypeApi.LEISTUNG && data.folder_type !== FolderTypeApi.LEISTUNG_OHNE_PREISE && data.folder_type !== FolderTypeApi.DOCUMENTATION) {
      FolderDialogStore.dismiss();
      this.createFolder(data, null);
    }
    //Special case for document folder
    else if (data.name != undefined && (data.folder_type == FolderTypeApi.FORMULAR || data.folder_type == FolderTypeApi.LEISTUNG || data.folder_type == FolderTypeApi.LEISTUNG_OHNE_PREISE || data.folder_type == FolderTypeApi.DOCUMENTATION)) {
      FolderDialogStore.dismiss();
      this.createFolder(data, data.files[0]);
    }
    //File upload
    else {
      FileUploadDialogStore.dismiss();
      ProgressDialogStore.show("Hochladen der Dateien...");
      this.processFiles(data.files, isReplace);
      ProgressDialogStore.dismiss();
      this.refresh();
    }
  }

  async processFiles(items: any, isReplace: boolean) {
    let promises;
    if (isReplace) {
      promises = items.map(this.replaceItem);
    } else {
      promises = items.map(this.createItem);
    }
    await Promise.all(promises);
  }

  replaceItem(item: any) {
    FileReplaceDialogStore.dismiss();
    if (this.toEdit) {
      Templates.updateTemplateFile((this.toEdit as Folder).files[0].id, item.name, item).then(res => {
        //@ts-ignore:
        let isError = res.message !== undefined;
        if (isError) {
          ErrorStore.showError((res as Errors).message.description)
        } else {
          SnackbarStore.show("Datei erfolgreich ersetzt.");
          this.refresh();
        }
      }).catch(res => {
        ErrorStore.showError("Fehler beim Ersetzen der Datei")
      })
    }
  }

  createItem(item: any) {
    if (this.toEdit) {
      Templates.createTemplateFile(item.name, this.toEdit.id, item).then(res => {
        //@ts-ignore:
        let isError = res.message !== undefined;
        if (isError) {
          ErrorStore.showError((res as Errors).message.description)
        } else {
          SnackbarStore.show("Erfolgreich hochgeladen.");
          this.refresh();
        }
      }).catch(res => {
        ErrorStore.showError("Fehler beim Erstellen der Dateien")
      })
    }
  }

  // createFolder(name: string, order_index: number, folderType: string, file: any) {
  createFolder(data: any, file: any) {
    let _order_index = data.order_index;
    let id = null;

    if (this.toEdit) {
      //@ts-ignore:
      if (this.toEdit.order_index) {
        //@ts-ignore:
        _order_index = this.toEdit.order_index;
      }
      id = this.toEdit.id;
    } else {
      //Offer
      if (this.tab == 0 && this.currentFolderOffer) {
        id = this.currentFolderOffer.id
      }
      //Project
      else if (this.tab == 1 && this.currentFolderProject) {
        id = this.currentFolderProject.id
      }
    }

    Templates.createTemplateFolder(
        data.name,
        _order_index,
        id,
        data.folder_type,
        file,
        data.demo_pdf_file,
        data.demo_video_url
    ).then(res => {
      //@ts-ignore:
      let isError = res.message !== undefined;
      if (isError) {
        ErrorStore.showError((res as Errors).message.description)
      } else {
        this.refresh();
      }
    }).catch(res => {
      ErrorStore.showError(res.message.description)
    })
  }

  //============================== END handling file/folder creation

  popOfferFolderStack() {
    if (this.previousFolderStackOffer.length > 1) {
      this.previousFolderStackOffer.pop();
      this.updateOfferFolderVariables(this.previousFolderStackOffer[this.previousFolderStackOffer.length - 1]);
    }
  }

  onOfferFolderClicked(folder: Folder) {
    this.updateOfferFolderVariables(folder)
    this.previousFolderStackOffer.push(folder);
  }

  updateOfferFolderVariables(folder: Folder) {
    this.currentFolderOffer = folder;
    if (folder.demo_video_url && folder.demo_video_url !== "") {
      this.currentFolderOfferDemoVideoUrl = folder.demo_video_url
    } else {
      this.currentFolderOfferDemoVideoUrl = ""
    }

    console.log("DEBUG", this.currentFolderOfferDemoVideoUrl);

    if (folder.demo_pdf_url && folder.demo_pdf_url !== "") {
      this.currentFolderOfferDemoPdf = folder.demo_pdf_url
    } else {
      this.currentFolderOfferDemoPdf = ""
    }
  }

  popProjectFolderStack() {
    if (this.previousFolderStackProject.length > 1) {
      this.previousFolderStackProject.pop();
      this.updateProjectFolderVariables(this.previousFolderStackProject[this.previousFolderStackProject.length - 1]);
    }
  }

  onProjectFolderClicked(folder: Folder) {
    this.updateProjectFolderVariables(folder);
    this.previousFolderStackProject.push(folder);
  }

  updateProjectFolderVariables(folder: Folder) {
    this.currentFolderProject = folder;
    if (folder.demo_video_url !== "") {
      this.currentFolderProjectDemoVideoUrl = folder.demo_video_url
    } else {
      this.currentFolderProjectDemoVideoUrl = ""
    }
    if (folder.demo_pdf_url !== "") {
      this.currentFolderProjectDemoPdf = folder.demo_pdf_url
    } else {
      this.currentFolderProjectDemoPdf = ""
    }
  }

  onFileClicked(file: File) {
    Templates.getCloudFile(file.id).then(res => {
      if (res.url && res.url.trim().length > 0) {
        window.open(res.url)
      }
    }).catch(res => {
      ErrorStore.showError("Datei konnte nicht zum Download abgerufen werden.")
    });
  }

  openHelpUrl(url: string) {
    window.open(url)
  }
}
